import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) =>({
    border: {
        borderBottom: "1px solid lightgray",
  },
}))

export const Separator = ({ height, width, showMidLine, ...props }) => {
    const classes = useStyles()
    
    if ( showMidLine === true ) {
        return (
            <>
              <div style={{height: height/2, width: "100%"}} className={classes.border}></div>
              <div style={{height: height/2, width: "100%"}}></div>
            </>
        )
    } else {
        return (
            <div style={{height: height, width: "100%"}}></div>
        )
    }

}
